import { render, staticRenderFns } from "./LanyardPanel.vue?vue&type=template&id=595e6565&scoped=true"
import script from "./LanyardPanel.vue?vue&type=script&lang=ts"
export * from "./LanyardPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LanyardPanel.vue?vue&type=style&index=0&id=595e6565&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./LanyardPanel.vue?vue&type=style&index=1&id=595e6565&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "595e6565",
  null
  ,true
)

export default component.exports